<script>
import { Bar, mixins} from "vue-chartjs";
export default {
  name: "barGraph",
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
  },
  data: function() {
    return {
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "white",
              },
              gridLines: {
                display: true,
                color: "gray",
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "white",

              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: true,
          labels: {
             fontColor: "white"
          }

        },
        tooltips: {
          enabled: true,
          mode: "single",
          fontColor: "primary",
          callbacks: {
            label: (tooltipItems) => tooltipItems.yLabel + " " + this.$t('Kg')
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200
      }
    };
  },
  mounted() {
    // this.chartdata is created in the mixin
    this.renderChart(this.chartData, this.options);
  },
};
</script>
<style>
</style>